import React from 'react'
import Header from '../../Components/Header';
import CompanyIntro from "./CompanyIntro";
import FeedbackSection from "./FeedbackSection";
// no hooks needed here


function FeedbackFormData({ feedbackData, cmsData }) {
  const data = feedbackData ?? cmsData ?? null;
  console.log("🔍 FeedbackFormData - feedbackData:", feedbackData);
  console.log("🔍 FeedbackFormData - cmsData:", cmsData);
  console.log("🔍 FeedbackFormData - data (final):", data);
  console.log("🔍 FeedbackFormData - data.Rating:", data?.Rating);
  return (
    <main className="relative w-full min-h-screen overflow-x-hidden">
      <Header />
      <div className="-mt-5">
        <CompanyIntro />
      </div>
      <FeedbackSection cmsData={data} />
      
     
    </main>
  );
}

export default FeedbackFormData;